<template>
  <v-navigation-drawer :value="drawerStatus" @input="$emit('input', $event)" app>
    <v-layout fill-height column>
      <!-- Toolbar header -->
      <v-toolbar class="yellow darken-4">
        <v-toolbar-title>
          <v-list class="drawer_list">
            <v-list-tile>
              <v-list-tile-avatar>
                <v-icon large>$vuetify.icons.rms_company</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title class="font-weight-bold">{{selectedCompany.title}}</v-list-tile-title>
                <v-list-tile-sub-title v-html="user.email"></v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-toolbar-title>
      </v-toolbar>

      <!-- Changable menu as per availLink user & other user -->
      <v-layout justify-space-between column>
        <ListMenu :menu="menu"></ListMenu>
        <!-- <FilterMenu v-model="drawerStatus"></FilterMenu> -->
      </v-layout>
      <Logout
        v-if="session_mode == DEFINES.AVAIL_SESSION_MODE"
        :btn_label="'Exit'"
        :redirect_to="'Exit'"
      ></Logout>
      <Logout v-else :btn_label="'Logout'" :redirect_to="'Login'"></Logout>
    </v-layout>
  </v-navigation-drawer>
</template>


<script>
import ListMenu from "@/components/ListMenu";
import FilterMenu from "./FilterMenu";
import Logout from "@/components/Logout";
import { mapGetters, mapState } from "vuex";

export default {
  name: "Drawer",
  props: ["drawer", "menu"],
  components: {
    FilterMenu,
    ListMenu,
    Logout
  },
  computed: {
    drawerStatus: {
      get() {
        return this.drawer;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    ...mapGetters({
      selectedCompany: "company/getSelectedCompany",
    }),
    ...mapState({
      session_mode: state => state.app.session_mode,
      user: state => state.user.profile
    })
  }
};
</script>
<style>
.drawer_list .v-list__tile {
  padding: 0 !important;
}
</style>
